/** Multiplies a value by a factor while handling null/undefined and avoiding precision issues */
export function multiplyWithPrecision<T extends number | null | undefined>(
  value: T,
  factor: number,
  decimalPlaces: number = 2
): T {
  if (value != null) {
    return Number((value * factor).toFixed(decimalPlaces)) as T;
  }

  return value;
}

/** Converts rate in BPS to rate in percents, while avoiding precision issues */
export function convertBpsToPercentage<T extends number | null | undefined>(valueInBps: T): T {
  return multiplyWithPrecision(valueInBps, 0.01);
}

/** Converts rate in percents to rate in BPS, while avoiding precision issues */
export function convertPercentageToBps<T extends number | null | undefined>(valueInPercentage: T): T {
  return multiplyWithPrecision(valueInPercentage, 100);
}

/** Converts a ratio (0-1) to percentage (0-100), while avoiding precision issues */
export function convertRatioToPercentage<T extends number | null | undefined>(ratio: T): T {
  return multiplyWithPrecision(ratio, 100);
}

export function roundNumber2digits(value: number): number {
  return Math.floor(value * 100) / 100;
}
